module.exports = new __parcel__URL__("fruit-eaten.7e0da0b9.mp3").toString();